import { Pipe, PipeTransform } from '@angular/core';

import { transformWebcamUrl } from '../constants/constants';
import moment from 'moment';

@Pipe({ name: 'webcamImageUrl' })
export class WebcamImageUrlPipe implements PipeTransform {
  transform(dtg: string, webcamImages: any[]) {
    const dtgFrom = moment(dtg).subtract(3, 'minutes');
    const dtgTo = moment(dtg).add(3, 'minutes');
    if (webcamImages === null) {
      return '';
    }
    for (const webcamImage of webcamImages) {
      if (moment(webcamImage['dtg']).isBetween(dtgFrom, dtgTo)) {
        return transformWebcamUrl(webcamImage['url']);
      }
    }
  }
}
